import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { sumInsuredamount,QuickQuoteHealth,PostQuoteHealth,ErrQuotesHealth } from "../../Redux/actions/NumHealth";
import { 
  Button, 
  Form,
  Radio,
  message
} from 'antd/lib';
import axiosInHealth from "../../Redux/axios/AxiosInHealth";
export default function InsurerFilter({setisModalInsurer}) {
    const dispatch = useDispatch();
    const Healthnum = useSelector((state) => state?.healthdetail?.healthnum);
  const QuotePost = useSelector((state) => state?.healthdetail?.QuickQuotePost);
    const QuickQuotes = useSelector((state) => state?.healthdetail?.quickquotes);
    console.log("QuickQuotes",QuickQuotes)
    const QuickQuotePost = useSelector((state) => state?.healthdetail?.quickQuotePost);
    const QuoteInput = useSelector((state) => state?.cardetail?.quoteInput);
    console.log(QuickQuotePost)
    const [loading, setLoading] = useState(false)


    const onChange = (e) => {
      console.log('radio checked', e.target.value);
      // setValue(e.target.value);
    };
    const onFinish = (values) => {
      console.log('product values',values)
    //   const UpdatePlan = {
    //     ...QuotePost,
    //     policyPeriod : values?.multiYear,
    //   }
    //   setLoading(true)
    //   axiosInHealth
    //   .post(`v1/health_insurances/${Healthnum?.health_insurance_id}/quick_quotes`, UpdatePlan)
    //     .then((res) => {
    //       if (res.status === 200) {
    //         const data = res?.data?.data
    //       console.log(data)
    //         const errData = data?.filter(item => ("status" in item && item.status === "failed"));
    //         dispatch(ErrQuotesHealth(errData));
    //         const filteredData = data?.filter(item => ("status" in item && item.status === "success"));
    //         dispatch(QuickQuoteHealth(filteredData));
    //         dispatch(PostQuoteHealth(UpdatePlan))
    //         setLoading(false)
    //         setisModalInsurer(false)
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err.response.data.error);
    //       setLoading(false)
    //       message.error(err.response.data.error);
    //     });
    }; 
  return (
    <>
       <Form
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        >
            <p className="border-bottom mb-0"
             style={{fontSize: "14px", paddingBottom:"10px"}}>Select the insurer of your choice and view plans offered by the selected insurer.</p>
          <Form.Item
          name="multiYear"
        // className="cvEditSec"
          rules={[
            {
              required: true,
              message: 'Please select Policy Type',
            },
          ]}
          initialValue={QuotePost?.policyPeriod}
          >
            <Radio.Group
              className="py-3 px-3 pb-0 bg-white ant-radio-layout filt-prod-sec-health"
              onChange={onChange}
              >
                {QuickQuotes?.map((item, index) => (
                    <Radio key={index} value={index}>
                    <div className="insu-pro-filter">
                        <img src={item?.logo} alt={item?.insurer} style={{width: "95px"}}/>
                        <p className="mb-0">{item?.insurer === 'go_digit' ? 'GO DIGIT' : item?.insurer}</p>
                    </div>
                    </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
            <Form.Item style={{textAlign: "center"}}>
                <Button type="primary" 
                htmlType="submit"
                className="update-qut-button"
                loading={loading}
                >Update</Button>
            </Form.Item>
        </Form>
    </>
  );
}